import React, { useEffect, useState } from "react";
import { Alert, Chip, Snackbar, Stack } from "@mui/material";
import { useAppSelector } from "../../../../../../app/hooks";
import { useVarianceSaveMutation } from "../../../../../../services/varianceService/variance-api";
import { useMyProfileQuery } from "../../../../../../services/profileService/profile-api";
import { IncidentWorklistBack } from "../IncidentWorklistBack";
import { VarianceDetailsSave } from "./VarianceDetailsSave";
import { VarianceCancelBtn } from "./VarianceCancelBtn";
import { VarianceApproveBtn } from "./VarianceApproveBtn";
import { VarianceSubmitForApprovalBtn } from "./VarianceSubmitForApprovalBtn";
import { VarianceCompleteBtn } from "./VarianceCompleteBtn";
import { VarianceRejectBtn } from "./VarianceRejectBtn";
import { IncidentAssignUserBtn } from "../AssignUser/IncidentAssignUserBtn";
import { LookupIncidentAssignUser } from "../AssignUser/lookupUser/LookupIncidentAssignUser";
import { VariancePendingApproveBtn } from "./VariancePendingApproveBtn";
import { VarianceReopenBtn } from "./VarianceReopenBtn";
import { CenterNameView } from "../../../../../../components/orgComponents/CenterNameView";
import { PermissionChecker } from "../../../../../../services/varianceService/util/PermissionChecker";
import { IncidentExportButtons } from "../Export/IncidentExportButtons";

function VarianceDetailsCommands() {
  const variance = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );
  const [, status] = useVarianceSaveMutation();
  const [notify, setNotify] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => {
    setNotify(status.isSuccess);
  }, [status.isSuccess]);
  const myProfile = useMyProfileQuery();
  
  const isApprover = () => {
    return PermissionChecker.isVarianceApprover(myProfile.data, variance.center);
  };
  
  const isCloser = () => {
    return PermissionChecker.isVarianceCloser(myProfile.data, variance.center);
  }
  
  const isIncidentAdmin = () => {
    return PermissionChecker.isVarianceAdmin(myProfile.data, variance.center);
  }
  
  const isAssignedOrQualityTeam = () => {
    return PermissionChecker.isAssignedOrQualityTeam(myProfile.data, variance, variance.center);
  }
  
  const isAssignedUser = () => {
    return PermissionChecker.isAssignedToVariance(myProfile.data, variance);
  }

  const canEdit = () => {
    return PermissionChecker.canEditVariance(myProfile.data, variance, variance.center);
  }

  return (
    <React.Fragment>
      <Stack direction="row" justifyContent="space-between" gap={1}>
        <CenterNameView centerId={variance.center!} />
        <Stack direction="row" justifyContent="centered" gap={1}>
          <Chip label={variance.incidentDisplayNumber} />
          <Chip
            label={variance.incidentDisplayStatus}
            color={"info"}
            variant="outlined"
          />
        </Stack>
        <Stack direction="row" gap={1}>
          {canEdit() && (
          <VarianceDetailsSave
            setNotify={setNotify}
            setMessage={setMessage}
          />)}

          {isCloser() && variance.status !== "Complete" && variance.status !== "Cancelled" && (
            <VarianceCompleteBtn 
              setNotify={setNotify}
              setMessage={setMessage}
            />
          )}

          {(variance.status === "Complete" || variance.status === "Cancelled") && isIncidentAdmin() && (
            <VarianceReopenBtn
              setNotify={setNotify}
              setMessage={setMessage}
            />
          )}
          
          {variance.status === "Started" && (
            <Stack direction="row" gap={1}>
              <VarianceSubmitForApprovalBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
              <VarianceCancelBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
            </Stack>
          )}
          {variance.status === "Pending" && isApprover() && (
            <Stack direction="row" gap={1}>
              <IncidentAssignUserBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
              <LookupIncidentAssignUser />
              <VarianceRejectBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
              <VarianceCancelBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
            </Stack>
          )}
          {variance.status === "Assigned" && isAssignedOrQualityTeam() && (
            <Stack direction="row" gap={1}>
              {isApprover() && (
                <IncidentAssignUserBtn
                  setNotify={setNotify}
                  setMessage={setMessage}
                />
              )}
              <LookupIncidentAssignUser />
              { isAssignedUser() && <VariancePendingApproveBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />}
              <VarianceRejectBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
              <VarianceCancelBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />              
            </Stack>
          )}
          {variance.status === "PendingApproval" && isApprover() && (
            <Stack direction="row" gap={1}>
              <VarianceApproveBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
              <VarianceRejectBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
              <VarianceCancelBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
            </Stack>
          )}

          {variance.status === "Approved" && isCloser() && (
            <Stack direction="row" gap={1}>
              <VarianceRejectBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
              <VarianceCancelBtn
                setNotify={setNotify}
                setMessage={setMessage}
              />
            </Stack>
          )}

          <IncidentExportButtons />
          <IncidentWorklistBack />
        </Stack>
      </Stack>
      <Snackbar
        open={notify}
        onClose={() => setNotify(false)}
        color="success"
        autoHideDuration={6000}
        message={message}
      />
      <Snackbar open={status.isError}>
        <Alert color="error">
          {"An error has occured: " + JSON.stringify(status.error)}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}

export { VarianceDetailsCommands };
